import { companyAvatar } from 'Services/avatarGenerator'

/**
 * @param {ApiCompanyAccount} data
 * @returns {CompanyAccount}
 */
export const parseCompanyAccount = (data) => {
  const info = {
    id: data.id,
    name: data.fancyName,
    slug: data.slug,
    logo: companyAvatar(data.logoSmallUrl, data.fancyName),
    about: data.about,
    serviceDescription: data.servicesDescription,
    advantangeList: data.differentials || [],
    endorsementList: data.references || [],
    website: data.site,
    waitingRegistration: data.waitingRegistration,
    is360Partner: data.is360Partner
  }

  const phone = {
    id: data.phone ? data.phone.id : 0,
    ddd: data.phone ? data.phone.ddd : '',
    number: data.phone ? data.phone.number : '',
    token: data.phone ? data.phone.token : '',
    isPhoneValidated: data.phone ? data.phone.isPhoneValidated : false,
  }

  return { phone, ...info }
}

/**
 * @param {ApiCompanyAccountPhoto} data
 * @returns {CompanyAccountPhoto}
 */
export const parseCompanyAccountPhoto = (data) => ({
  id: data.id,
  mimeType: data.mimeType,
  description: data.caption,
  small: {
    src: data.imageSmallPath,
    width: data.widthImageSmall,
    height: data.heightImageSmall,
  },
  medium: {
    src: data.imageMediumPath,
    width: data.heightImageMedium,
    height: data.heightImageMedium,
  },
  large: {
    src: data.heightImageMedium,
    width: data.widthImageLarge,
    height: data.heightImageLarge,
  }
})

/**
 * @param {Array.<ApiCompanyAccountPhoto>} data
 * @returns {Array.<CompanyAccountPhoto>}
 */
export const parseCompanyAccountPhotoList = (data) => {
  return data.map(parseCompanyAccountPhoto).reverse()
}

export default {
  parseCompanyAccount,
  parseCompanyAccountPhoto,
  parseCompanyAccountPhotoList,
}